var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo0(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 36,
    viewBox: "0 0 148 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.1353 9.60059H60.168V26.4006H63.1353V9.60059Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3576 25.9925H90.3903V18.2321C90.3903 16.6393 89.0827 15.3432 87.4758 15.3432C85.8689 15.3432 84.5614 16.6393 84.5614 18.2321V25.9925H81.5933V18.2321C81.5933 15.0168 84.2322 12.4019 87.475 12.4019C90.7186 12.4019 93.3567 15.0177 93.3567 18.2321V25.9925H93.3576Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.849 25.9925H98.8821V18.2321C98.8821 16.6393 97.5746 15.3432 95.9677 15.3432C94.3608 15.3432 93.0532 16.6393 93.0532 18.2321V25.9925H90.0859V18.2321C90.0859 15.0168 92.7249 12.4019 95.9677 12.4019C99.2113 12.4019 101.849 15.0177 101.849 18.2321V25.9925V25.9925Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.417 26.2157H130.45V18.8493C130.45 16.9157 128.863 15.3432 126.913 15.3432C124.963 15.3432 123.376 16.9157 123.376 18.8493V26.2157H120.408V18.8493C120.408 15.2941 123.326 12.4019 126.913 12.4019C130.499 12.4019 133.417 15.2941 133.417 18.8493V26.2157Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M144.854 12.7998H137.39V15.7411H144.854V12.7998Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M141.417 26.3169C138.303 26.3169 135.77 23.8059 135.77 20.7191V9.60059H138.738V20.7191C138.738 22.1843 139.94 23.3756 141.417 23.3756C142.896 23.3756 144.097 22.1835 144.097 20.7191H147.065C147.065 23.8059 144.531 26.3169 141.417 26.3169Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.17 20.4515H67.4453V18.0005H78.7371L79.17 19.2005V20.4515Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1804 21.968C74.452 22.7196 73.4361 23.1643 72.3367 23.1643C70.1609 23.1643 68.3911 21.41 68.3911 19.2533C68.3911 17.0965 70.1609 15.3422 72.3367 15.3422C74.5125 15.3422 76.2823 17.0965 76.2823 19.2533H79.2496C79.2496 15.4749 76.1484 12.4009 72.3367 12.4009C68.525 12.4009 65.4238 15.4749 65.4238 19.2533C65.4238 23.0316 68.525 26.1057 72.3367 26.1057C75.113 26.1057 77.5847 24.4849 78.6807 21.968H75.1804V21.968Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1454 20.4515H46.4207V18.0005H57.7125L58.1454 19.2005V20.4515Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1559 21.968C53.4276 22.7196 52.4117 23.1643 51.3123 23.1643C49.1365 23.1643 47.3667 21.41 47.3667 19.2533C47.3667 17.0965 49.1365 15.3422 51.3123 15.3422C53.4881 15.3422 55.2579 17.0965 55.2579 19.2533H58.2252C58.2252 15.4749 55.124 12.4009 51.3123 12.4009C47.5006 12.4009 44.3994 15.4749 44.3994 19.2533C44.3994 23.0316 47.5006 26.1057 51.3123 26.1057C54.0886 26.1057 56.5603 24.4849 57.6563 21.968H54.1559V21.968Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M118.29 20.4515H106.663V18.0005H117.955L118.29 19.2255V20.4515Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M113.992 21.968C113.263 22.7196 112.248 23.1643 111.148 23.1643C108.972 23.1643 107.203 21.41 107.203 19.2533C107.203 17.0965 108.972 15.3422 111.148 15.3422C113.324 15.3422 115.094 17.0965 115.094 19.2533H118.061C118.061 15.4749 114.96 12.4009 111.148 12.4009C107.337 12.4009 104.235 15.4749 104.235 19.2533C104.235 23.0316 107.337 26.1057 111.148 26.1057C113.925 26.1057 116.396 24.4849 117.492 21.968H113.992V21.968Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3387_2356)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6985 22.058V10.8323L32.1073 6.89111V17.9372L24.6985 22.058Z",
    fill: "url(#paint0_linear_3387_2356)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9441 26.0679L20.024 35.5519L19.7582 35.6991L9.78809 30.2209V26.0679H19.9441Z",
    fill: "url(#paint1_linear_3387_2356)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6988 27.3926V32.9587L19.7583 35.6987V27.3926H24.6988Z",
    fill: "url(#paint2_linear_3387_2356)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9086 19.2102L14.9123 19.212L14.7265 24.7781L17.2673 26.1876L7.31575 31.7215L7.16892 31.6371L7.12988 20.6753L17.2859 14.9512V17.8043L14.9086 19.2102Z",
    fill: "url(#paint3_linear_3387_2356)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.31777 20.67L0 16.6121V11.0459L7.51294 15.0284L7.31777 20.67Z",
    fill: "url(#paint4_linear_3387_2356)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5776 19.2627L24.6985 24.5613V30.307L34.5776 24.8289V19.2627Z",
    fill: "url(#paint5_linear_3387_2356)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.37915 17.8496L7.31963 20.6776V31.7237L2.37915 28.8957V17.8496Z",
    fill: "#29F6A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7266 24.7801V19.214L14.7953 19.1709L24.6967 24.5647V30.3104L14.7266 24.7801Z",
    fill: "url(#paint6_linear_3387_2356)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.97388 16.474L0 11.0461L9.97388 5.61816V16.474Z",
    fill: "url(#paint7_linear_3387_2356)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5778 19.2627L24.6987 24.7409L14.7249 19.2088L17.2899 17.7814L17.2694 17.7921L19.7583 19.1729L24.6504 16.4509L24.6987 13.7827L34.5778 19.2627Z",
    fill: "url(#paint8_linear_3387_2356)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2879 15.1326L17.2898 15.1308L17.169 15.1972L12.2712 12.5272L9.78613 13.9744V2.73979L10.1151 2.55664L19.9422 8.21796L19.8771 19.1635L19.7563 19.2641L17.2693 17.7936L17.2879 15.1326Z",
    fill: "url(#paint9_linear_3387_2356)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.6177,
    y: 6.68457,
    width: 20.0742,
    height: 16.878,
    fill: "url(#pattern0)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7582 19.2303V8.21825L19.6504 8.159L24.6503 5.45312L24.6968 5.47826V16.4831L19.7582 19.2303Z",
    fill: "url(#paint10_linear_3387_2356)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2916 15.1312L7.31777 20.6776L2.37915 17.8497L12.2731 12.3481L17.2916 15.1312Z",
    fill: "url(#paint11_linear_3387_2356)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6985 11.0119V5.47803L27.1687 4.06494L32.1092 6.89291L24.6985 11.0119Z",
    fill: "url(#paint12_linear_3387_2356)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.78809 2.73999L19.7582 8.21817L24.6987 5.47818L14.7267 0L9.78809 2.73999Z",
    fill: "#76FF0B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3387_2356"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3387_2356",
    x1: 28.171,
    y1: 8.49972,
    x2: 28.611,
    y2: 20.6833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004A4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3387_2356",
    x1: 9.7877,
    y1: 30.8834,
    x2: 20.0248,
    y2: 30.8834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ECD59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16DE3E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3387_2356",
    x1: 22.2281,
    y1: 26.6891,
    x2: 22.2281,
    y2: 35.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007649"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3387_2356",
    x1: 20.1699,
    y1: 22.2945,
    x2: 11.0485,
    y2: 23.5905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9935,
    stopColor: "#007258"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3387_2356",
    x1: 3.70879,
    y1: 13.0301,
    x2: 3.81878,
    y2: 19.9754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12C951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009256"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3387_2356",
    x1: 24.6976,
    y1: 24.7862,
    x2: 34.5767,
    y2: 24.7862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008147"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3387_2356",
    x1: 20.5372,
    y1: 20.5378,
    x2: 19.3379,
    y2: 27.1176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44E28D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10E2AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3387_2356",
    x1: 0,
    y1: 11.0454,
    x2: 9.97349,
    y2: 11.0454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91FF3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64F562"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3387_2356",
    x1: 14.723,
    y1: 19.2635,
    x2: 34.5769,
    y2: 19.2635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91FF3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DE2AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3387_2356",
    x1: 14.8041,
    y1: 5.37457,
    x2: 14.9159,
    y2: 16.4817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03E168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05C35E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3387_2356",
    x1: 20.1098,
    y1: 7.75064,
    x2: 23.459,
    y2: 15.5516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00837B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03824D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3387_2356",
    x1: 4.92177,
    y1: 19.3511,
    x2: 14.0517,
    y2: 13.6545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91FF3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52F171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3387_2356",
    x1: 24.5251,
    y1: 9.08792,
    x2: 29.1162,
    y2: 5.40465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11E2AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6377,
    stopColor: "#8DFE40"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3387_2356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.7143,
    height: 36,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3387_2356",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGwAAABeCAYAAADG1PFrAAAACXBIWXMAAAsSAAALEgHS3X78AAAA"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo0);
export default __webpack_public_path__ + "static/media/logo0.21440909cc91a9bff84a88446350fed0.svg";
export { ForwardRef as ReactComponent };